const PageHeader = ({ title }) => {
  return (
    <div className="page-title">
      <div className="container-fluid">
        <h1 className="text-white">{title}</h1>
      </div>
    </div>
  );
};

export default PageHeader;
